module.exports = __webpack_public_path__ + "static/media/newUser.1e3312f0.svg";